<template>
    <div>
        <app-wysiwyg
            label="Überschrift"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.title'"
            textpicker-namespace="awards/title"
            required
            :maxlength="255"
            :slim="true"
        ></app-wysiwyg>

        <app-wysiwyg
            label="Unterüberschrift"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.subtitle'"
            textpicker-namespace="awards/subtitle"
            required
            :maxlength="255"
            :slim="true"
        ></app-wysiwyg>

        <app-wysiwyg
            label="Text"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.text'"
            textpicker-namespace="awards/text"
            :maxlength="1024"
        ></app-wysiwyg>

        <app-link
            v-if="hasPackageBasic"
            label="Button 1"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.link'"
        ></app-link>

        <app-link
            v-if="hasPackageBasic"
            label="Button 2"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.link2'"
        ></app-link>

        <app-link
            v-if="hasPackageBasic"
            label="Button 3"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.link3'"
        ></app-link>

        <app-list
            :data-source="'deha.user.misc.awards'"
            :data-preset="false"
            :data-name="'data.name'"
            :list-subpage="'Awards'"
            :allow-individual="true"
            :label="'Auszeichnung'"
        ></app-list>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Text from '@/components/fields/simple/Text.vue';
import Wysiwyg from '@/components/fields/simple/Wysiwyg.vue';
import Link from '@/components/assorted/Link.vue';
import List from '@/components/fields/complex/List.vue';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {
        ...mapGetters(['getProp', 'hasPackageBasic'])
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R005'),
            help: this.$helpers.uiText('R053'),
            removeText: this.$helpers.uiText('R054'),
            showGlobal: false
        });
    },
    props: {
        moduleId: String
    },
    components: {
        'app-text': Text,
        'app-wysiwyg': Wysiwyg,
        'app-link': Link,
        'app-list': List
    }
};
</script>
